import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import {fetchProjects} from '../actions/projectsActions';

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      imageCount: 0
    };
  }

  componentWillMount() {
    this.props.fetchProjects();
    setTimeout(
      function () {
        this.setState({isWaiting: false});
      }.bind(this),
      1000
    );
  }

  componentDidUpdate(prevProps) {
    const {isFetching, projects} = this.props;
    if (!isFetching && isFetching !== prevProps.isFetching) {

      const images = [];
      for (const projectName in projects) {

        const currentProject = projects[projectName];
        images.push(this.imageLoaded(currentProject.background, ''));
        images.push(this.imageLoaded(currentProject.cover, ''));
        currentProject.details.forEach(detail => {
          if (detail.type === 'image') {
            images.push(this.imageLoaded(detail.value, ''));
          }
        });
      }

      this.imagesLength = images.length;

      Promise.all(images).then(() => this.setState({isLoading: false}));
    }
  }

  imageLoaded(src, alt = '') {
    const self = this;
    return new Promise(function (resolve) {
      const image = document.createElement('img');

      image.setAttribute('alt', alt);
      image.setAttribute('src', src);

      image.addEventListener('load', function () {
        resolve(image);
        self.setState(({imageCount}) => ({imageCount: imageCount + 1}));
      });
    });
  }

  render() {
    const {imageCount, isLoading} = this.state;
    const progress = (imageCount / this.imagesLength) * 100;
    const loadingIndicator = (
      <div>
        <p id="loading-progress">{~~progress + '%'}</p>
        <img id="loading-logo" src={require('../assets/images/logo_fade_anim.gif')}/>
      </div>
    );

    return (
      <div id="app-wrapper">
        <Sidebar/>
        {
          isLoading ? loadingIndicator : (
            <div id="loaded-content-wrapper">
              {this.props.children}
            </div>
          )
        }

      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object,
  fetchProjects: PropTypes.func,
  isFetching: PropTypes.bool,
  projects: PropTypes.object
};

const mapStateToProps = state => {
  return {
    isFetching: state.projects.isFetching,
    projects: state.projects.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchProjects: bindActionCreators(fetchProjects, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js